import "@fontsource/pt-sans";
import "@fontsource/montserrat-alternates";

import ApplyForm from './send_form';
import { refreshCsrfToken } from './refresh-csrf-token';

window.addEventListener('DOMContentLoaded', event => {

    window.bootstrap = require('./bootstrap.bundle.min.js');

    //old yookassa style
    if (document.getElementById("course-registration-form")) {
        new ApplyForm("course-registration-form");
    }

    //yookasa payment
    if (document.getElementById("course-registration-form-payment")) {
        const form = document.getElementById("course-registration-form-payment");
		const formMessage = document.getElementById("course-registration-form-message");
        const termsOfUse = document.getElementById("terms-of-use");
        const submit = form.querySelector('.form-submit-btn');

        //Use assortment of product (radio select)
        const radioCoureTitles = document.querySelectorAll(".js-radio-course-title");
        const radioCourePrice = document.getElementById("js-course-price");

		//Hide message
		if(formMessage){
			formMessage.style.visibility = "hidden";
		}


        if (radioCoureTitles.length > 0) {
            const descriptionField = form.querySelector("#description");
            const priceField = form.querySelector("#price");
            const infoField = document.querySelector("#js-course-info");

            for (let item of radioCoureTitles) {
                item.firstElementChild.addEventListener('change', function (e) {
                    if (descriptionField) {
                        descriptionField.value = e.target.value;
                    }
                    if (priceField) {
                        priceField.value = e.target.dataset.price;
                    }
                    if (radioCourePrice) {
                        radioCourePrice.innerHTML = e.target.dataset.price;
                    }
                    if (infoField) {
                        infoField.innerHTML = e.target.dataset.info;
                    }
                    return true;
                });
            }
        }


        //terms of use
        if (termsOfUse && submit) {
            termsOfUse.addEventListener('change', function (e) {
                if (!e.target.checked) {
                    submit.setAttribute("disabled", null);
                } else {
                    submit.removeAttribute("disabled");
                }
            });
        }

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            const name = document.getElementById('name').value;
            const email = document.getElementById('email').value;
            if (
                submit &&
                !submit.hasAttribute("disabled") &&
                name &&
                email
            ) {
                // Disable submit button to prevent double submission
                if (submit) {
                    submit.disabled = true;
                    submit.value = 'Отправка...';
                }
                
                // Refresh CSRF token before submitting to prevent 419 errors
                refreshCsrfToken(form)
                    .then(result => {
                        if (result.success) {
                            // Submit the form after token is refreshed
                            e.target.submit();
                        } else {
                            // If token refresh failed, show error and re-enable button
                            if (submit) {
                                submit.disabled = false;
                                submit.value = 'Оплатить';
                            }
                            alert('Не удалось обновить токен безопасности. Пожалуйста, обновите страницу и попробуйте снова.');
                        }
                    })
                    .catch(error => {
                        console.error('Error refreshing CSRF token:', error);
                        // If error occurred, try to submit anyway (maybe token is still valid)
                        e.target.submit();
                    });
            } else {
                return false;
            }

        });

    }

    // Navbar shrink function
    var navbarShrink = function () {
        const navbarCollapsible = document.body.querySelector('#mainNav');
        if (!navbarCollapsible || !navbarCollapsible.classList) {
            return;
        }
        if (window.scrollY === 0) {
            navbarCollapsible.classList.remove('navbar-shrink')
        } else {
            navbarCollapsible.classList.add('navbar-shrink')
        }

    };

    // Shrink the navbar 
    navbarShrink();

    // Shrink the navbar when page is scrolled
    document.addEventListener('scroll', navbarShrink);

    // Activate Bootstrap scrollspy on the main nav element
    const mainNav = document.body.querySelector('#mainNav');
    if (mainNav) {
        try {
            // Check if there are nav links with href anchors before initializing ScrollSpy
            const navLinks = mainNav.querySelectorAll('a[href^="#"]');
            if (navLinks.length > 0) {
                new bootstrap.ScrollSpy(document.body, {
                    target: '#mainNav',
                    offset: 72,
                });
            }
        } catch (e) {
            console.warn('Bootstrap ScrollSpy initialization failed:', e);
        }
    }

    // Collapse responsive navbar when toggler is visible
    const navbarToggler = document.body.querySelector('.navbar-toggler');

    if (navbarToggler) {
        navbarToggler.addEventListener('click', function () {
            const animatedIcon = this.querySelector('.animated-icon');
            if (animatedIcon && animatedIcon.classList) {
                animatedIcon.classList.toggle('open');
            }
        });
    }

    // Find responsive nav items - check for both possible IDs
    const navbarCollapse = document.querySelector('#navbarCollapse');
    const navbarResponsive = document.querySelector('#navbarResponsive');
    const responsiveNavItems = [];
    
    if (navbarCollapse) {
        const collapseItems = navbarCollapse.querySelectorAll('.nav-link');
        if (collapseItems.length > 0) {
            responsiveNavItems.push(...Array.from(collapseItems));
        }
    }
    
    if (navbarResponsive) {
        const responsiveItems = navbarResponsive.querySelectorAll('.nav-link');
        if (responsiveItems.length > 0) {
            responsiveNavItems.push(...Array.from(responsiveItems));
        }
    }
    
    if (responsiveNavItems.length > 0 && navbarToggler) {
        responsiveNavItems.forEach(function (responsiveNavItem) {
            if (responsiveNavItem) {
                responsiveNavItem.addEventListener('click', () => {
                    if (navbarToggler && window.getComputedStyle(navbarToggler).display !== 'none') {
                        navbarToggler.click();
                    }
                });
            }
        });
    }



});
